module.exports = __webpack_public_path__ + "static/media/about-new-check.50eb0229.jpg";